// extracted by mini-css-extract-plugin
export var acceptButton = "_1b-6";
export var backdropBlur = "_1b-0";
export var fullContent = "_1b-5";
export var link = "_1b-7";
export var linkIcon = "_1b-8";
export var sideContent = "_1b-4";
export var sideImage = "_1b-3";
export var sideImageWrapper = "_1b-2";
export var splitLayout = "_1b-1";